// extracted by mini-css-extract-plugin
module.exports = {"root":"ExitRegistrationMode_root__1PnIF"};